import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, PageEvent, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GatewayService } from '../../gateway.service';
import { LocalSaveService } from '../../services/local-save-service.service';
import { ResourceLockService } from '../../services/resource-lock.service';

const SUPERVISOR_IDROLES = [3, 10, 15, 16];

@Component({
    selector: 'app-nuevas-ordenes-sin-cita',
    templateUrl: './nuevas-ordenes-sin-cita.component.html',
    styleUrls: ['./nuevas-ordenes-sin-cita.component.scss']
})
export class NuevasOrdenesSinCitaComponent implements OnInit, OnDestroy {

    displayedColumns = ['numero_orden', 'cuenta', 'telefono', 'des_nombre_cliente', 'provincia', 'distrito', 'corregimiento', 'raised_date', 'fechacreacion', 'atendido_por', 'ultima_gestion'];
    dataSource = new MatTableDataSource<any>([]);
    total = 0;
    page = 1;
    pageSize = 50;
    isLoading = false;

    search = '';
    fechaDesde: string | null = null;
    fechaHasta: string | null = null;

    provincias: any[] = [];
    distritos: any[] = [];
    corregimientos: any[] = [];
    id_provincia: number | null = null;
    id_distrito: number | null = null;
    id_corregimiento: number | null = null;

    @ViewChild(MatPaginator, { static: false } as any) paginator: MatPaginator;

    puedeVer = false;
    esSupervisor = false;
    private locksSub: Subscription | null = null;

    constructor(
        private gateway: GatewayService,
        private snackBar: MatSnackBar,
        private router: Router,
        private localSave: LocalSaveService,
        public resourceLock: ResourceLockService
    ) {}

    private _tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
        const user = this.localSave.get('usuarioPGV');
        if (!user || !user.permisos) return false;
        const perm = user.permisos.find((p: any) => p.modulo === modulo);
        if (!perm) return false;
        return perm['permiso_' + tipo] === 1;
    }

    async ngOnInit() {
        const user = this.localSave.get('usuarioPGV');
        const esSuperAdmin = user && user.esSuperAdmin;
        this.puedeVer = esSuperAdmin || this._tienePermiso('ORDENES_SIN_CITA');
        if (!this.puedeVer) {
            this.router.navigate(['/home']);
            return;
        }
        this.esSupervisor = !!(user && (esSuperAdmin || SUPERVISOR_IDROLES.includes(Number(user.idrol))));

        await this.resourceLock.loadInitial('nueva_orden_sin_cita');
        this.locksSub = this.resourceLock.locks$.subscribe(() => {
            if (this.dataSource && this.dataSource.data) {
                this.dataSource = new MatTableDataSource([...this.dataSource.data]);
            }
        });

        this.gateway.get('getprovincias', {}).then((res: any) => {
            this.provincias = (res && res.rows) ? res.rows : [];
        }).catch(() => { this.provincias = []; });

        this.cargar();
    }

    ngOnDestroy() {
        if (this.locksSub) {
            this.locksSub.unsubscribe();
            this.locksSub = null;
        }
    }

    async onLiberar(row: any): Promise<void> {
        if (!row || row.id_base == null) return;
        const ok = await this.resourceLock.forceRelease('nueva_orden_sin_cita', String(row.id_base));
        const msg = ok ? 'Orden liberada' : 'No se pudo liberar la orden';
        this.snackBar.open(msg, 'OK', { duration: 3000 });
    }

    cargar() {
        this.isLoading = true;
        const payload = {
            page: this.page,
            pageSize: this.pageSize,
            search: this.search ? this.search.trim() : null,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            id_provincia: this.id_provincia,
            id_distrito: this.id_distrito,
            id_corregimiento: this.id_corregimiento
        };
        this.gateway.get('nuevasOrdenesSinCitaListar', payload)
            .then((res: any) => {
                this.isLoading = false;
                if (!res || res.response !== 1) {
                    const msg = res && res.message ? res.message : 'Error al cargar';
                    this.snackBar.open(msg, 'OK', { duration: 3000 });
                    this.dataSource = new MatTableDataSource([]);
                    this.total = 0;
                    return;
                }
                this.dataSource = new MatTableDataSource(res.rows || []);
                this.total = res.total || 0;
            })
            .catch((err: any) => {
                this.isLoading = false;
                console.error('[nuevas-ordenes-sin-cita] error:', err);
                this.snackBar.open('Error de red al cargar órdenes', 'OK', { duration: 3000 });
            });
    }

    onPage(ev: PageEvent) {
        this.page = ev.pageIndex + 1;
        this.pageSize = ev.pageSize;
        this.cargar();
    }

    onBuscar() {
        this.page = 1;
        if (this.paginator) this.paginator.firstPage();
        this.cargar();
    }

    onProvinciaChange(): void {
        this.id_distrito = null;
        this.id_corregimiento = null;
        this.distritos = [];
        this.corregimientos = [];
        if (this.id_provincia == null) return;
        this.gateway.get('getdistritosxprovincia', { id_padre: this.id_provincia })
            .then((res: any) => { this.distritos = (res && res.rows) ? res.rows : []; })
            .catch(() => { this.distritos = []; });
    }

    onDistritoChange(): void {
        this.id_corregimiento = null;
        this.corregimientos = [];
        if (this.id_distrito == null) return;
        this.gateway.get('getcorregimientosxdistrito', { id_padre: this.id_distrito })
            .then((res: any) => { this.corregimientos = (res && res.rows) ? res.rows : []; })
            .catch(() => { this.corregimientos = []; });
    }

    onLimpiar() {
        this.search = '';
        this.fechaDesde = null;
        this.fechaHasta = null;
        this.id_provincia = null;
        this.id_distrito = null;
        this.id_corregimiento = null;
        this.distritos = [];
        this.corregimientos = [];
        this.page = 1;
        if (this.paginator) this.paginator.firstPage();
        this.cargar();
    }
}
